module.exports = __webpack_public_path__ + "media/images/flags/yt-5c77b04743aada260f6b0daaa7c08793.svg";